import React, { ReactElement, Component, useContext, useMemo, useEffect } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import "./tools.less";
import { ThemeContext } from "../../contexts/theme";
import { config, kubectl } from "../../img";
import { RightOutlined } from "@ant-design/icons";
import { TableListModalTypeContext, table_list_modal_type } from "../../contexts/table_list_modal";
import { ToolsCloseContext } from "../../contexts/tools_close";
import { item } from "../../contexts/items";
import { ClusterContext, clusters_type_item } from "../../contexts/clusters";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";

const Tools: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const theme: string = useContext(ThemeContext)[0],
    set_table_list_modal: React.Dispatch<React.SetStateAction<table_list_modal_type>> = useContext(TableListModalTypeContext)[1],
    set_tools_close: React.Dispatch<React.SetStateAction<boolean>> = useContext(ToolsCloseContext)[1],
    clusters: clusters_type_item[] = useContext(ClusterContext)[0],
    set_cluster_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(ClusterSelectedContext)[1],
    { formatMessage } = useMemo(() => props.intl, [props]);

  useEffect((): void => {
    if (clusters) {
      const data: string = sessionStorage.getItem("cluster") || "",
        selected = Array.isArray(clusters) && clusters.find((cluster: clusters_type_item) => cluster.metadata && cluster.metadata.name === data);
      if (selected) set_cluster_selected(selected.metadata);
      else if (clusters.length) {
        const { metadata }: clusters_type_item = clusters[0];
        set_cluster_selected(metadata);
        sessionStorage.setItem("cluster", metadata?.name);
      } else set_cluster_selected(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusters, set_cluster_selected]);

  return (
    <div className={`tools_content_${theme}`} data-tut="reactour_step1">
      <h3 className="tool_title">
        <FormattedMessage id="toolbox" />
        <span className="title_icon" role="img" aria-label="title_icon">
          💡
        </span>
      </h3>
      <p className="tool_desc">
        <FormattedMessage id="toolbox_desc" />
      </p>
      <ul>
        <div
          className="tool_link"
          onClick={(e: any) => {
            e.stopPropagation();
            set_tools_close(false); //设置无guidance时toolbox框关闭
            set_table_list_modal((currentState) => ({
              ...currentState,
              visible: true,
              is_config: true,
            }));
          }}
        >
          <span>
            <img src={config} alt="" />
          </span>
          <span className="pl-6 translate_right">config</span>
          <RightOutlined className="right_icon" />
        </div>
        <div
          className="tool_link"
          onClick={(e: any) => {
            e.stopPropagation();
            set_tools_close(false); //设置无guidance时toolbox框关闭
            set_table_list_modal((currentState) => ({
              ...currentState,
              visible: true,
              modal_title: formatMessage({ id: "web_kubectl" }),
              is_web_kubectl: true,
            }));
          }}
        >
          <span>
            <img src={kubectl} alt="" />
          </span>
          <span className="pl-6 translate_right">Web Kubectl</span>
          <RightOutlined className="right_icon" />
        </div>
      </ul>
    </div>
  );
};

export default injectIntl(Tools);
